// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3X1e3","label":"Completed_label__SYMWk"};